import React from 'react';
import { DialogPayload } from '@ianesthesie-kit/redux';
import type { AppDialogType as AppDialogTypeT } from '@/config';
import dynamic from 'next/dynamic';
import type { RegistrationHospitalConfirmationDialogProps } from './RegistrationHospitalConfirmationDialogContent';
import { DynamicDialogLoader } from '../common';

const DialogContent = dynamic<RegistrationHospitalConfirmationDialogProps>(
  () =>
    import('./RegistrationHospitalConfirmationDialogContent').then(
      (m) => m.RegistrationHospitalConfirmationDialogContent
    ),
  {
    ssr: false,
    loading: DynamicDialogLoader
  }
);

export const RegistrationHospitalConfirmationDialog = (
  props: DialogPayload<AppDialogTypeT & any> &
    RegistrationHospitalConfirmationDialogProps
) => <DialogContent {...props} />;
